import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Corner Frame layout — editorial/asymmetric style.
 * L-shaped corner brackets frame the content area.
 * Footer pinned at bottom for cross-template consistency.
 */
export function CornerFrameLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  const bracketColor = pc.accent(0.35);
  const bracketW = '80px';
  const bracketH = '80px';
  const bracketBorder = '2px';

  return (
    <div className="absolute inset-0">
      {/* Top-left bracket */}
      <div className="absolute top-[48px] left-[48px]" style={{ width: bracketW, height: bracketH }}>
        <div className="absolute top-0 left-0 right-0" style={{ height: bracketBorder, backgroundColor: bracketColor }} />
        <div className="absolute top-0 left-0 bottom-0" style={{ width: bracketBorder, backgroundColor: bracketColor }} />
      </div>

      {/* Top-right bracket */}
      <div className="absolute top-[48px] right-[48px]" style={{ width: bracketW, height: bracketH }}>
        <div className="absolute top-0 left-0 right-0" style={{ height: bracketBorder, backgroundColor: bracketColor }} />
        <div className="absolute top-0 right-0 bottom-0" style={{ width: bracketBorder, backgroundColor: bracketColor }} />
      </div>

      {/* Bottom-left bracket */}
      <div className="absolute bottom-[48px] left-[48px]" style={{ width: bracketW, height: bracketH }}>
        <div className="absolute bottom-0 left-0 right-0" style={{ height: bracketBorder, backgroundColor: bracketColor }} />
        <div className="absolute top-0 left-0 bottom-0" style={{ width: bracketBorder, backgroundColor: bracketColor }} />
      </div>

      {/* Bottom-right bracket */}
      <div className="absolute bottom-[48px] right-[48px]" style={{ width: bracketW, height: bracketH }}>
        <div className="absolute bottom-0 left-0 right-0" style={{ height: bracketBorder, backgroundColor: bracketColor }} />
        <div className="absolute top-0 right-0 bottom-0" style={{ width: bracketBorder, backgroundColor: bracketColor }} />
      </div>

      {/* Logo */}
      {logoEnabled && (
        <NudgeableGroup groupId="logo" className="absolute top-[72px] left-[80px]">
          <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.55) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
        </NudgeableGroup>
      )}

      {/* Content area (bottom portion) */}
      <NudgeableGroup groupId="content" className="absolute left-[80px] right-[80px] bottom-[140px] top-[50%] flex flex-col justify-end">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            mutedOpacity: 0.65,
            subtleOpacity: 0.40,
          }}
        />
      </NudgeableGroup>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
